import { PerformanceOverTimeContentWrapper } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTime.styles';
import { PerformanceOverTimeContentLoading } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeContentLoading';
import { GraphTabs } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeGraphTabs';
import { PeformanceOverTimeMetricCards } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeMetricCards';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';

export const PerformanceOverTimeContent = () => {
  const { isLoading } = useFroInsightsCoreContext();
  if (isLoading) {
    return (
      <PerformanceOverTimeContentWrapper>
        <PerformanceOverTimeContentLoading />
      </PerformanceOverTimeContentWrapper>
    );
  }

  return (
    <PerformanceOverTimeContentWrapper>
      <GraphTabs />
      <PeformanceOverTimeMetricCards />
    </PerformanceOverTimeContentWrapper>
  );
};
